import React, { useState } from "react";
import "../components/Login/login.css";
import loginIcon from "../assets/icons/login.svg";
import logoEja from "../assets/img/logo-eja-600x600.png";
import loginData from "../services/login";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    let formData = new FormData();
    formData.append("correo", email);
    formData.append("password", password);

    loginData(formData).then((response) => {
      let _respuesta = JSON.parse(response);

      if (_respuesta.response === "success") {
        localStorage.setItem("login", true);
        localStorage.setItem("idUsuario", _respuesta.data.id_usuario);
        navigate("/");
      } else {
        Swal.fire(
          "Datos incorrectos",
          "Por favor verifica el correo y la contraseña.",
          "warning"
        );
      }
    });
  };

  function onChangeEmail(e) {
    setEmail(e.target.value);
  }

  function onChangePassword(e) {
    setPassword(e.target.value);
  }

  return (
    <div className="container-fluid login p-0">
      <div className="row d-flex align-items-center">
        <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center order-1 order-sm-1 order-md-1 order-lg-0 order-xl-0 order-xxl-0">
          <img src={loginIcon} alt="Login" className="img-fluid" />
        </div>
        <div className="col-12 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-5 order-0 order-sm-0 order-md-0 order-lg-1 order-xl-1 order-xxl-1">
          <div className="text-center login__logo">
            <img src={logoEja} alt="Login" />
          </div>
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="correo" className="form-label">
                Correo
              </label>
              <input
                type="email"
                className="form-control"
                id="correo"
                aria-describedby="emailHelp"
                onChange={onChangeEmail}
                required
              />
              <div id="emailHelp" className="form-text">
                Recuerda que este dato te lo genera el administrador.
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="exampleInputPassword1" className="form-label">
                Contraseña
              </label>
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                onChange={onChangePassword}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary login__button">
              Iniciar sesión
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
